import { useState } from 'react';

/**
 * A box in the right-hand sidebar.
 *
 * The sidebar is sticky and does not scroll, which is fine while reading but
 * not while editing: the boxes below the fold — cover image, summary — could
 * not be reached at all. Collapsing the ones above them is the first answer to
 * that; making the column itself scrollable is a separate decision.
 */
function SidebarPanel({
  icon,
  title,
  badge,
  modifierClass,
  ariaHidden,
  collapsible = false,
  defaultOpen = true,
  headerAction,
  children,
}) {
  const [isOpen, setOpen] = useState(defaultOpen);

  const heading = (
    <>
      <i className={icon} />
      <span>{title}</span>

      {badge != null && badge > 0 && (
        <span className="tags-count">{badge}</span>
      )}

      {headerAction}
    </>
  );

  return (
    <section
      className={[
        'rightbox',
        modifierClass,
        collapsible ? 'rightbox-collapsible' : '',
        collapsible && !isOpen ? 'collapsed' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden={ariaHidden}
    >

      {collapsible ? (
        <h3 className="rightbox-heading">
          <button
            type="button"
            className="rightbox-toggle"
            aria-expanded={isOpen}
            onClick={() => setOpen((open) => !open)}
          >
            <i className={icon} />
            <span>{title}</span>

            {badge != null && badge > 0 && (
              <span className="tags-count">{badge}</span>
            )}
          </button>

          {headerAction}
          <button
            type="button"
            className="rightbox-toggle"
            aria-label={title}
            aria-expanded={isOpen}
            onClick={() => setOpen((open) => !open)}
          >
            <i
              className="fa-solid fa-chevron-down rightbox-chevron"
              aria-hidden="true"
            />
          </button>
        </h3>

      ) : (
        <h3>{heading}</h3>
      )}
      <div className="rightbox-body" hidden={collapsible && !isOpen}>
        {children}
      </div>
    </section>
  );
}

export default SidebarPanel;
